import { BreakpointObserver } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { IsActiveMatchOptions, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { IconV3Component } from '@gea/digital-ui-lib';
import { isMobileNavigationUrl, MOBILE_NAVIGATION_ITEMS, MOBILE_VIEW_QUERY } from '../../utils/mobile-navigation.utils';

@Component({
    selector: 'app-mobile-navigation',
    standalone: true,
    imports: [RouterLink, RouterLinkActive, IconV3Component],
    templateUrl: './mobile-navigation.component.html',
    styleUrl: './mobile-navigation.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileNavigationComponent implements OnInit {
    readonly navigationItems = MOBILE_NAVIGATION_ITEMS;
    readonly activeMatchOptions: IsActiveMatchOptions = {
        paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored'
    };

    constructor(
        private readonly breakpointObserver: BreakpointObserver,
        private readonly router: Router,
        private readonly destroyRef: DestroyRef
    ) { }

    ngOnInit(): void {
        this.breakpointObserver.observe(MOBILE_VIEW_QUERY)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(({ matches }) => {
                if (matches && this.router.navigated && !isMobileNavigationUrl(this.router.parseUrl(this.router.url))) {
                    this.router.navigateByUrl(MOBILE_NAVIGATION_ITEMS[0].path, { replaceUrl: true });
                }
            });
    }
}